import React from 'react'
import { Link } from "react-router-dom";


const HomeAbout1 = () => {
  return (
    <>
        <section className="about-section section-padding fix header-bg">
                <div className="container">
                    <div className="about-wrapper-2">
                        <div className="top-shape wow img-custom-anim-left" data-wow-duration="1.3s" data-wow-delay="0.3s">
                            <img src="assets/img/about/blue-shape.png" alt="img" />
                        </div>
                        <div className="border-shape  wow img-custom-anim-right" data-wow-duration="1.3s" data-wow-delay="0.3s">
                            <img src="assets/img/about/shape-1.png" alt="img" />
                        </div>
                        <div className="bottom-shape wow img-custom-anim-right" data-wow-duration="1.3s" data-wow-delay="0.3s">
                            <img src="assets/img/about/blue-shape.png" alt="img" />
                        </div>
                        <div className="row g-4 align-items-center">
                            <div className="col-lg-6">
                                <div className="about-image">
                                    <img src="assets/img/svp/03-modified.png" alt="img" className="wow img-custom-anim-top" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="about-content">
                                    <div className="section-title">
                                        <span className="text-white sub-title wow fadeInUp">About Us</span>
                                        <h2 style={{fontSize:"26px"}} className="text-white wow fadeInUp" data-wow-delay=".3s">
                                            Boost Your Career by Learning New Skills
                                        </h2>
                                        <p className="text-white mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s">
                                            The purpose of education is to create. Build as a means to an end as well as an end in itself. This concept obviously contradicts the long-held belief that a child is a "clean slate." Every student, regardless of level, has a unique set of experiences and tales to share. HR. SEC. Saraswati Vidyapeeth. The teaching used in schools does not completely disregard their past experiences. Instead, we suitably expand upon, question, and cultivate what they bring. This ensures that the child is not just a recipient but also an active participant in the learning process. In order to remain current and child-centered, this construction-based learning approach continuously changes and poses the following queries.
                                        </p>
                                    </div>
                                    <div className="list-item">
                                        <div className="list-bar">
                                            <ul className="list wow fadeInUp" data-wow-delay=".7s">
                                                <li>
                                                    <img src="assets/img/icon/cheak-2.svg" alt="img" />
                                                    fully CCTV Campus
                                                </li>
                                                <li>
                                                    <img src="assets/img/icon/cheak-2.svg" alt="img" />
                                                    20-25 Student in each Classroom
                                                </li>
                                                <li>
                                                    <img src="assets/img/icon/cheak-2.svg" alt="img" />
                                                    Hygienic lunch facility
                                                </li>
                                            </ul>
                                            <div className="about-button wow fadeInUp" data-wow-delay=".3s">
                                                <Link to="/about" className="theme-btn bg-white">More About Us <i className="fa-solid fa-arrow-right" /></Link>
                                            </div>
                                        </div>
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    </>
  )
}

export default HomeAbout1